// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconCurrentPath = 'M9 17.938V16.71h2v1.228A8.004 8.004 0 0 0 17.938 11H16.71V9h1.228A8.004 8.004 0 0 0 11 2.062V3.29H9V2.062A8.004 8.004 0 0 0 2.062 9H3.29v2H2.062A8.004 8.004 0 0 0 9 17.938ZM10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm5.417-15.416-2.713 8.124-8.12 2.708 2.708-8.124 8.125-2.708Zm-6.544 4.29-1.126 3.379 3.376-1.127 1.129-3.379-3.379 1.126Z';
var IconCurrent = baseIcon('IconCurrent', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconCurrentPath
});
export default IconCurrent;
//# sourceMappingURL=index.js.map